import clsx from 'clsx';
import { useEffect, useState } from 'react';

//components
import ConnectWithUs from './connect-with-us';
import CsrDropdownMenu from './csr-dropdown-menu';
import DropdownBtn from './footer-drop-down-btn';
import ShortcutLinks from './short-cut-links';

//styles
import styles from './footer-csr-menu.module.scss';
import { CMSData } from '@/types/cmsData';
import { useCommonContextProps } from '@/hooks';
import { useStore } from '@/store/useStore';
import { useIntl } from 'react-intl';

const FooterCSR = () => {
  // const { isMobile } = useContext(ScreenWidthContext);
  const isMobile = false;

  //default state
  const [shortCutLinks, setShortCutLinks] = useState<CMSData>();
  const [shopCustomerService, setShopCustomerService] = useState<CMSData>();
  const [offers, setOffers] = useState<CMSData>();
  const [pcOptProg, setPcOptProg] = useState<CMSData>();
  const [aboutShoppers, setAboutShoppers] = useState<CMSData>();
  const [customerService, setCustomerService] = useState<CMSData>();
  const [inStore, setInStore] = useState<CMSData>();
  const [isExpanded, setIsExpanded] = useState(false);

  const { locale } = useCommonContextProps();
  const { formatMessage } = useIntl();

  const data = useStore(({ headerFooter }) => headerFooter);

  //reset dropdown on screen size change
  useEffect(() => {
    setIsExpanded(false);
  }, [isMobile]);

  useEffect(() => {
    if (data && !(data instanceof Error) && data[locale].footer) {
      for (let group of data[locale].footer) {
        switch (group.uid) {
          case 'FrontShopFooterShopNavNode': {
            setShortCutLinks(group);
            break;
          }
          case 'FrontShopFooterCustomerServiceNavNode': {
            setShopCustomerService(group);
            break;
          }
          case 'FrontShopFooterOffersNavNode': {
            setOffers(group);
            break;
          }
          case 'FrontShopFooterPCOptimumProgramNavNode': {
            setPcOptProg(group);
            break;
          }
          case 'FrontShopFooterAboutShoppersDrugMartNavNode': {
            setAboutShoppers(group);
            break;
          }
          case 'FrontShopFooterSDMCustomerServiceNavNode': {
            setCustomerService(group);
            break;
          }
          case 'FrontShopFooterVisitAStoreNavNode': {
            setInStore(group);
            break;
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeof data, locale]);

  return (
    <div className={styles.csrWrapper}>
      {isMobile ? (
        <div className={styles.csrMenuContainer}>
          <ConnectWithUs />
          <ShortcutLinks shortCutLinks={shortCutLinks} shopCustomerService={shopCustomerService} />
        </div>
      ) : (
        <>
          <div className={styles.csrMenuContainer}>
            <ShortcutLinks shortCutLinks={shortCutLinks} shopCustomerService={shopCustomerService} />
            <ConnectWithUs />
          </div>
          <div className={clsx(styles.moreFrom, !isExpanded && styles.dropDownClosed)}>
            <p className={styles.moreFromText}>{formatMessage({ id: 'moreFromHeading' })}</p>
            <DropdownBtn isDropDownOpen={isExpanded} setIsDropDownOpen={setIsExpanded} />
          </div>
        </>
      )}

      {isExpanded || isMobile ? (
        <CsrDropdownMenu
          offers={offers}
          pcOptProg={pcOptProg}
          aboutShoppers={aboutShoppers}
          customerService={customerService}
          inStore={inStore}
        />
      ) : null}
    </div>
  );
};

export default FooterCSR;
